import React, { useEffect } from "react";
import { SpinnerLoading } from "../../components/Loadings";

const TermsAndCondition = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.open("https://arrivo.ai/terms-and-conditions/", "_blank");
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
      <div className="text-center">
        <SpinnerLoading />
        <p className="mt-3">Opening Terms and Conditions...</p>
      </div>
    </div>
  );
};

export default TermsAndCondition;